
import { loadWidget } from '../utils/load-widget';

loadWidget('favorites-modal', {
    data: function() {
        return {
            ViewModel: {
                ModalActive: false,
                toggleEventFavoriteCallback: null,
                closeModalCallback: null,
            },
            ParentViewModel: null,
        };
    },
    methods: {
        closeModal: function () {
            this.ViewModel.ModalActive = false;
            this.ViewModel.closeModalCallback();
        },
        toggleEventFavorite: function (event) {
            this.ViewModel.toggleEventFavoriteCallback(event);
        }
    },
    beforeMount() {
        this.$root.$on('openFavoritesModal', (viewModel, toggleEventFavoriteCallback, closeModalCallback) => {
            this.ParentViewModel = viewModel;
            this.ViewModel.ModalActive = true;
            this.ViewModel.toggleEventFavoriteCallback = toggleEventFavoriteCallback;
            this.ViewModel.closeModalCallback = closeModalCallback;
        });
    }
});